// eslint
/* global cast */

export default class CastQueue extends cast.framework.QueueBase {
    /**
     * @param {Logger} logger
     */
    constructor(logger) {
        super();
        this.logger = logger;
    }

    /**
     * Initializes the queue.
     * @param {!cast.framework.messages.LoadRequestData} requestData
     * @return {!cast.framework.messages.QueueData}
     * or non-null Promise containing nullable cast.framework.messages.QueueData
     */
    initialize(requestData) {
        this.logger.info('Initialize CastQueue', requestData);
        if (typeof (requestData.queueData) === 'undefined') {
            this.logger.info('No queueData found, default behaviour');
            return null; // enable default behaviour
        }
        this.logger.info('Queuedata found!');
        const queueData = requestData.queueData || new cast.framework.messages.QueueData();
        return queueData;
    }
}
